export default __webpack_public_path__ + "static/media/germany.19d2315b.svg";